
import Vue from 'vue';
import Component from 'vue-class-component';
import {Watch} from 'vue-property-decorator';
import {StudentProgram, CourseRecord, LessonRecord} from '../student-program';
import * as $ from 'jquery';
import {onVisibilityChange, offVisibilityChange} from '../on-visibility-change';

const MIN_REFRESH = 60000;

@Component({
})
export default class CourseLessonNav extends Vue {
	program:StudentProgram|null = null;
	programLoaded:number;
	scrollTopsByPath:any;
	_visHandler:((v:boolean)=>void)|null = null;
	_scrollHandler:((v:boolean)=>void)|null = null;

	constructor() {
		super();
		this.programLoaded = Date.now();
	}

	clickBackButton() {
		let params = {
			courseId: this.$route.params.courseId,
			lessonId: this.$route.params.lessonId,
		};

		if (this.$route.params.skipped) {
			delete params.lessonId;
			delete params.courseId;
		} else if (params.lessonId) {
			delete params.lessonId;
		} else if (params.courseId) {
			delete params.courseId;
		}

		this.$router.push({name:'courseLessonNav', params});
	}

	get course() {
		if (typeof this.$route.params.courseId !== 'undefined' && this.program
				&& this.program.courseRecords) {
			let courseId:number = parseInt(this.$route.params.courseId);
			let course:CourseRecord|null = null;
			this.program.courseRecords.forEach((cr) => {
				if (courseId === cr.courseId) {
					course = cr;
				}
			})
			return course;
		} else {
			return null;
		}
	}

	get navLevel():number {
		let $route = this.$route;
		return (!$route.params.courseId && !$route.params.lessonId) ? 0 : (
					(!$route.params.lessonId) ? 1 : 2);
	}

	get lessons() {
		if (this.course) {
			return this.course.lessonRecords;
		} else {
			return [];
		}
	}

	get percentDone() {
		if (this.program && this.program.percentDone) {
			return Math.round(this.program.percentDone);
		} else {
			return 0;
		}
	}

	get lesson() {
		if (this.course && this.$route.params.lessonId) {
			let lesson:LessonRecord|null = null;
			let lessonId:number = parseInt(this.$route.params.lessonId);
			this.course.lessonRecords.forEach((lr) => {
				if (lr.lessonId === lessonId) {
					lesson = lr;
				}
			});
			return lesson;
		} else {
			return null;
		}
	}

	@Watch('$route.path')
	manageScrolling() {
		let top = this.scrollTopsByPath[this.$route.path] || 0;
		$('html, body').animate({scrollTop: top}, 400);
	}

	@Watch('$route.params.lessonId', {immediate:true})
	loadLessonIfNeeded(newLessonId:string, oldLessonId) {

		if (oldLessonId && !newLessonId) {
			this.reloadProgram();
		}


		Vue.nextTick(() => { // wait for the DOM
			this.$refs.lessonLoadTarget.innerHTML = '';
			if (newLessonId) {
				$(this.$refs.lessonLoadTarget).load('../lesson/' + newLessonId + '/', () => {
					// FIXME: some kind of loading indicator should be switched off here
					console.log('done loading lesson');
				});
			}

		})
	}

	reloadProgram() {
		$.getJSON('./json-update/', (data) => {
			this.program = data;
			this.programLoaded = Date.now();
		});
	}

	created() {
		this.scrollTopsByPath = {};
		this.program = window.STUDENT_PROGRAM_DUMP ||
				{"courseRecords":[],percentDone:0,gpa:null,letterGrade:null,score:null};
		this._visHandler = (v:boolean) => this.onVisibilityChange(v);
		onVisibilityChange(this._visHandler);
		this._scrollHandler = () => {
			let top = $(window).scrollTop();
			this.scrollTopsByPath[this.$route.path] = top;
		};
		$(window).on('scroll', this._scrollHandler);
	}

	beforeDestroy() {
		if (this._visHandler) {
			offVisibilityChange(this._visHandler);
		}

		if (this._scrollHandler) {
			$(window).off('scroll', this._scrollHandler);
			this._scrollHandler = null;
		}

		if (this._resizeHandler) {
			$(window).off('resize', this._resizeHandler);
			this._resizeHandler = null;
		}
	}

	onVisibilityChange(visible:boolean) {
		if (visible) {
			if ((Date.now() - this.programLoaded) > MIN_REFRESH) {
				this.reloadProgram();
			}
		}
	}

}
